@if (!event().parentId) {
  <!-- @TODO: deberia validar el estado del evento -->
  <!-- @if (eventDrawings().length) { -->
    <div class="row">
      <div class="col-12">
        <h4>Resumen categoría</h4>

        <event-overview-ui
          [tournament]="tournament()"
          [event]="event()"
          [drawings]="eventDrawings()"
          [games]="eventGames()"
        ></event-overview-ui>

        <!-- <mat-divider></mat-divider> -->
      </div>
    </div>
  <!-- } -->
}

@if (event().title2) {
  <div class="row" [ngClass]="{'mt-50': !event().parentId}">
    <div class="col-12 d-flex">
      <h4>{{ event().title2 }}</h4>
      <progress-bar-ui
        [drawings]="eventDrawings()"
        [games]="eventGames()"
        class="ml-30"
      ></progress-bar-ui>
    </div>
  </div>
}

<!-- @TODO: deberia validar el estado del evento -->
@if (!eventDrawings().length) {
  <div role="alert" class="alert alert-daxa">
    Todavía no ha comenzado este evento
  </div>
} @else {
  <!-- @TODO: usar enum -->
  @if (event().config?.format === 'round_robin') {
    <groups-ui
      [event]="event()"
      [drawings]="eventDrawings()"
      [games]="eventGames()"
      [groupsRankings]="eventGroupsRankings()"
    ></groups-ui>
  <!-- @TODO: usar enum -->
  } @else if (event().config?.format === 'single_elimination') {
    <!-- @TODO: numbersQualifiersPerGroup: obtenerlo de la config del evento -->
    <div class="row">
      <div class="col-12">
        <draws-ui
          [drawings]="eventDrawings()"
          [parentEventDrawings]="parentEventDrawings()"
          [games]="eventGames()"
          [isBackdraw]="event().config?.isBackdraw || false"
          [numberGroups]="numberGroups()"
          [numbersQualifiersPerGroup]="numbersQualifiersPerGroup()"
        ></draws-ui>
      </div>
    </div>
  }
}

@if (!event().parentId) {
  @if (event().children?.length) {
    @for (childEvent of event().children; track childEvent.id) {
      <div class="row mt-50">
        <div class="col-12">
          @if (childEvent.title1) {
            <h4>{{ childEvent.title1 }}</h4>
          }

          <event-ui
            [event]="childEvent"
            [drawings]="drawings()"
            [games]="games()"
            [groupsRankings]="groupsRankings()"
            [numbersQualifiersPerGroup]="event().config?.numberOfPlayersToMainDraw"
          ></event-ui>
        </div>
      </div>
    }
  }

  @if (eventEventsRankings !== undefined) {
    <div class="row mt-50">
      <div class="col-12">
        <event-ranking-ui
          [eventsRankings]="eventEventsRankings()"
        ></event-ranking-ui>
      </div>
    </div>
  }
}
